<expandable titulo="Exames e Prescrições" icone="hgi-file-attachment" class="exames-prescricoes" [alertas]="0">

    <div class="itens">
        <ng-container *ngFor="let pedido of pedidos">
            <exame-prescricao [pedido]="pedido" [profissional]="consulta.profissionalSaude"
                [consulta]="consulta"></exame-prescricao>
        </ng-container>

        <ng-container *ngFor="let anexo of anexos">
            <anexos-consulta [anexo]="anexo" [consulta]="consulta"></anexos-consulta>
        </ng-container>

        <div class="options">
            <button *ngIf="exibirOpcoes" type="button" class="btn btn-lg btn-block btn-outline-secondary" (click)="solicitarExame()">
                <span>Solicitar exame</span>
                <i class="hgi hgi-stroke hgi-document-attachment"></i>
            </button>
            <button *ngIf="exibirOpcoes" type="button" class="btn btn-lg btn-block btn-outline-secondary" (click)="anexarPrescricao()">
                <span>Anexar prescrição</span>
                <i class="hgi hgi-stroke hgi-prescription"></i>
            </button>
            <button type="button" class="btn btn-lg btn-block btn-outline-secondary" (click)="anexarArquivo()">
                <span>Anexar arquivo</span>
                <i class="hgi hgi-stroke hgi-file-attachment"></i>
            </button>
        </div>
    </div>
</expandable>